<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title invoice-modal-title">
            {{ editMode ? "EDYTUJ DANE DO FAKTURY" : "DODAJ DANE DO FAKTURY" }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Type toggle -->
          <div class="invoice-radio-row">
            <label class="invoice-radio">
              <input type="radio" value="PRIVATE" v-model="invoiceType" />
              <span>Osoba prywatna</span>
            </label>
            <label class="invoice-radio">
              <input type="radio" value="COMPANY" v-model="invoiceType" />
              <span>Firma</span>
            </label>
          </div>

          <!-- OSOBA PRYWATNA -->
          <template v-if="invoiceType === 'PRIVATE'">
            <div class="invoice-form-box">
              <div class="invoice-row">
                <div class="invoice-field invoice-field-half">
                  <label class="invoice-label">Imię<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.first_name_invoice" />
                </div>
                <div class="invoice-field invoice-field-half">
                  <label class="invoice-label">Nazwisko<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.last_name_invoice" />
                </div>
              </div>
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Adres</label>
                  <input class="invoice-input" v-model="addressAutocomplete" placeholder="Wpisz adres..." />
                </div>
              </div>
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 3;">
                  <label class="invoice-label">Ulica<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.street_invoice" />
                </div>
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Numer domu<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.number1_invoice" />
                </div>
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Numer lokalu</label>
                  <input class="invoice-input" v-model="form.number2_invoice" />
                </div>
              </div>
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Miejscowość<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.city_invoice" />
                </div>
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Kod pocztowy<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.postcode_invoice" />
                </div>
              </div>
            </div>
          </template>

          <!-- FIRMA -->
          <template v-if="invoiceType === 'COMPANY'">
            <!-- GUS Search -->
            <div class="invoice-search-box">
              <p class="invoice-search-label">Wyszukaj firmę</p>
              <div class="invoice-radio-row" style="margin-bottom: 8px;">
                <label class="invoice-radio">
                  <input type="radio" value="nip" v-model="searchType" /> <span>NIP</span>
                </label>
                <label class="invoice-radio">
                  <input type="radio" value="regon" v-model="searchType" /> <span>REGON</span>
                </label>
                <label class="invoice-radio">
                  <input type="radio" value="krs" v-model="searchType" /> <span>KRS</span>
                </label>
              </div>
              <input class="invoice-input" v-model="searchValue" :placeholder="searchType.toUpperCase()" style="width: 250px;" />
              <div class="mt-2">
                <button class="invoice-btn-search" :disabled="searching || !searchValue" @click="performSearch">WYSZUKAJ</button>
              </div>
              <div v-if="searching" class="mt-2" style="color: rgba(9,7,65,0.5); font-size: 14px;">
                Trwa wyszukiwanie...
              </div>
              <div v-if="searchError" class="mt-2" style="color: #e3443f; font-size: 14px;">{{ searchError }}</div>
            </div>

            <!-- GUS result preview -->
            <div v-if="!editMode && companyFound && gusResult" class="invoice-result-box">
              <p class="invoice-result-name">{{ gusResult.name }}</p>
              <div class="invoice-result-grid">
                <div>
                  <span class="invoice-result-label">NIP</span>
                  <span class="invoice-result-value">{{ gusResult.nip }}</span>
                </div>
                <div>
                  <span class="invoice-result-label">REGON</span>
                  <span class="invoice-result-value">{{ gusResult.regon }}</span>
                </div>
                <div>
                  <span class="invoice-result-label">KRS</span>
                  <span class="invoice-result-value">{{ gusResult.krs || "-" }}</span>
                </div>
              </div>
              <div class="invoice-result-grid mt-2">
                <div>
                  <span class="invoice-result-label">Ulica</span>
                  <span class="invoice-result-value">{{ gusResult.street }} {{ gusResult.propertyNumber }}<template v-if="gusResult.apartmentNumber">/{{ gusResult.apartmentNumber }}</template></span>
                </div>
                <div>
                  <span class="invoice-result-label">Miejscowość</span>
                  <span class="invoice-result-value">{{ gusResult.city }}</span>
                </div>
                <div>
                  <span class="invoice-result-label">Kod pocztowy</span>
                  <span class="invoice-result-value">{{ gusResult.postalCode }}</span>
                </div>
              </div>
            </div>

            <!-- Company form (edit mode only) -->
            <div v-if="editMode" class="invoice-form-box">
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">NAZWA FIRMY<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.company_name" />
                </div>
              </div>
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 1; position: relative;">
                  <label class="invoice-label">NIP<span v-if="!gusLocked" class="req">*</span></label>
                  <input class="invoice-input" v-model="form.company_nip" :disabled="gusLocked" />
                  <span v-if="gusLocked" class="invoice-lock">&#128274;</span>
                </div>
                <div class="invoice-field" style="flex: 1; position: relative;">
                  <label class="invoice-label">REGON</label>
                  <input class="invoice-input" v-model="form.company_regon" :disabled="gusLocked" />
                  <span v-if="gusLocked" class="invoice-lock">&#128274;</span>
                </div>
                <div class="invoice-field" style="flex: 1; position: relative;">
                  <label class="invoice-label">KRS</label>
                  <input class="invoice-input" v-model="form.company_krs" :disabled="gusLocked" />
                  <span v-if="gusLocked" class="invoice-lock">&#128274;</span>
                </div>
              </div>
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 3;">
                  <label class="invoice-label">Ulica<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.street_invoice" />
                </div>
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Numer domu<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.number1_invoice" />
                </div>
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Numer lokalu</label>
                  <input class="invoice-input" v-model="form.number2_invoice" />
                </div>
              </div>
              <div class="invoice-row">
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Miejscowość<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.city_invoice" />
                </div>
                <div class="invoice-field" style="flex: 1;">
                  <label class="invoice-label">Kod pocztowy<span class="req">*</span></label>
                  <input class="invoice-input" v-model="form.postcode_invoice" />
                </div>
              </div>
            </div>
          </template>

          <button class="invoice-btn-save mt-3" @click="saveData">Zapisz</button>
        </div>
        <div class="modal-footer">
          <button ref="dismissBtn" type="button" class="invoice-btn-close" data-dismiss="modal">Zamknij</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios";

export default {
  name: "InvoiceDataModal",
  props: ["modalId", "profile", "userId", "editMode", "fieldPrefix"],
  emits: ["saved"],
  data() {
    return {
      invoiceType: "PRIVATE",
      searchType: "nip",
      searchValue: "",
      searching: false,
      searchError: "",
      companyFound: false,
      gusLocked: false,
      gusResult: null,
      addressAutocomplete: "",
      form: {
        invoice_type: "PRIVATE",
        first_name_invoice: "",
        last_name_invoice: "",
        company_name: "",
        company_nip: "",
        company_regon: "",
        company_krs: "",
        street_invoice: "",
        number1_invoice: "",
        number2_invoice: "",
        floor_invoice: "",
        city_invoice: "",
        postcode_invoice: "",
      },
    };
  },
  watch: {
    profile: {
      handler(p) {
        if (p && this.editMode) {
          this.fillFormFromProfile(p);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    pf(field) {
      return (this.fieldPrefix || "") + field;
    },
    fp(p, field) {
      return p[this.pf(field)] || "";
    },
    fillFormFromProfile(p) {
      const type = this.fp(p, 'invoice_type');
      const name = this.fp(p, 'company_name');
      if (type === "COMPANY" || (!type && name)) {
        this.invoiceType = "COMPANY";
        this.companyFound = true;
        this.gusLocked = true;
      } else {
        this.invoiceType = "PRIVATE";
      }
      this.form.invoice_type = this.invoiceType;
      this.form.first_name_invoice = this.fp(p, 'first_name_invoice');
      this.form.last_name_invoice = this.fp(p, 'last_name_invoice');
      this.form.company_name = this.fp(p, 'company_name');
      this.form.company_nip = this.fp(p, 'company_nip');
      this.form.company_regon = this.fp(p, 'company_regon');
      this.form.company_krs = this.fp(p, 'company_krs');
      this.form.street_invoice = this.fp(p, 'street_invoice');
      this.form.number1_invoice = this.fp(p, 'number1_invoice');
      this.form.number2_invoice = this.fp(p, 'number2_invoice');
      this.form.floor_invoice = this.fp(p, 'floor_invoice');
      this.form.city_invoice = this.fp(p, 'city_invoice');
      this.form.postcode_invoice = this.fp(p, 'postcode_invoice');
    },
    async performSearch() {
      this.searching = true;
      this.searchError = "";
      const cleanValue = this.searchValue.replace(/[\s-]/g, "");
      try {
        const response = await axios.get(`/api/gus/search/${this.searchType}/${cleanValue}`);
        const data = response.data;
        if (!data.name) {
          this.searchError = "Sprawdź wprowadzone dane i spróbuj ponownie";
          this.gusResult = null;
          this.companyFound = false;
          return;
        }
        this.gusResult = data;
        this.companyFound = true;
        this.gusLocked = true;
        this.form.company_name = data.name;
        this.form.company_nip = data.nip;
        this.form.company_regon = data.regon || "";
        this.form.company_krs = data.krs || "";
        this.form.street_invoice = data.street || "";
        this.form.number1_invoice = data.propertyNumber || "";
        this.form.number2_invoice = data.apartmentNumber || "";
        this.form.city_invoice = data.city || "";
        this.form.postcode_invoice = data.postalCode || "";
      } catch (err) {
        this.searchError = "Sprawdź wprowadzone dane i spróbuj ponownie";
        this.gusResult = null;
        this.companyFound = false;
      } finally {
        this.searching = false;
      }
    },
    buildPayload() {
      const prefix = this.fieldPrefix || "";
      const payload = {};
      payload[prefix + "invoice_type"] = this.invoiceType;
      const fields = [
        "first_name_invoice", "last_name_invoice",
        "company_name", "company_nip", "company_regon", "company_krs",
        "street_invoice", "number1_invoice", "number2_invoice",
        "floor_invoice", "city_invoice", "postcode_invoice",
      ];
      fields.forEach(f => { payload[prefix + f] = this.form[f]; });
      const clearedFields = this.invoiceType === "COMPANY"
        ? ["first_name_invoice", "last_name_invoice"]
        : ["company_name", "company_nip", "company_regon", "company_krs"];
      clearedFields.forEach(f => { payload[prefix + f] = ""; });
      return payload;
    },
    validateForm() {
      const errors = [];
      if (this.invoiceType === "PRIVATE") {
        if (!this.form.first_name_invoice || this.form.first_name_invoice.trim().length < 1) errors.push("Imię jest wymagane");
        if (!this.form.last_name_invoice || this.form.last_name_invoice.trim().length < 1) errors.push("Nazwisko jest wymagane");
        if (this.form.first_name_invoice && this.form.first_name_invoice.length > 512) errors.push("Imię max 512 znaków");
        if (this.form.last_name_invoice && this.form.last_name_invoice.length > 512) errors.push("Nazwisko max 512 znaków");
      } else {
        if (!this.form.company_name || this.form.company_name.trim().length < 1) errors.push("Nazwa firmy jest wymagana");
        if (this.form.company_name && this.form.company_name.length > 512) errors.push("Nazwa firmy max 512 znaków");
        if (!this.form.company_nip || this.form.company_nip.replace(/[\s-]/g, "").length !== 10) errors.push("NIP musi mieć 10 cyfr");
      }
      if (!this.form.street_invoice || this.form.street_invoice.trim().length < 1) errors.push("Ulica jest wymagana");
      if (this.form.street_invoice && this.form.street_invoice.length > 512) errors.push("Ulica max 512 znaków");
      if (!this.form.number1_invoice || this.form.number1_invoice.trim().length < 1) errors.push("Numer domu jest wymagany");
      if (!this.form.city_invoice || this.form.city_invoice.trim().length < 1) errors.push("Miejscowość jest wymagana");
      if (this.form.city_invoice && this.form.city_invoice.length > 512) errors.push("Miejscowość max 512 znaków");
      if (!this.form.postcode_invoice || this.form.postcode_invoice.trim().length < 1) errors.push("Kod pocztowy jest wymagany");
      return errors;
    },
    async saveData() {
      const errors = this.validateForm();
      if (errors.length > 0) {
        this.$notify({ group: "error", text: errors[0] });
        return;
      }
      const payload = this.buildPayload();
      try {
        await axios.put(`/api/admin/profile/${this.userId}/invoiceAddress`, payload);
        this.$notify({ group: "success", text: "Dane do faktury zostały zapisane" });
        this.$emit("saved");
        this.$refs.dismissBtn.click();
      } catch (err) {
        this.$notify({ group: "error", text: "Nie udało się zapisać danych" });
      }
    },
  },
};
</script>

<style scoped>
.invoice-modal-title {
  font-weight: 700;
  font-size: 18px;
  color: #090741;
  text-transform: uppercase;
}
.invoice-radio-row {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}
.invoice-radio {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #090741;
}
.invoice-form-box {
  border: 1px solid rgba(9, 7, 65, 0.15);
  border-radius: 5px;
  padding: 16px 20px;
}
.invoice-row {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}
.invoice-row:last-child {
  margin-bottom: 0;
}
.invoice-field {
  display: flex;
  flex-direction: column;
  position: relative;
}
.invoice-field-half {
  flex: 1;
}
.invoice-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(9, 7, 65, 0.75);
  margin-bottom: 2px;
  text-transform: uppercase;
}
.req {
  color: #e2037e;
  margin-left: 1px;
}
.invoice-input {
  border: none;
  border-bottom: 1px solid rgba(9, 7, 65, 0.25);
  outline: none;
  padding: 4px 0;
  font-size: 15px;
  color: #090741;
  background: transparent;
  width: 100%;
}
.invoice-input:focus {
  border-bottom-color: #090741;
}
.invoice-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.invoice-lock {
  position: absolute;
  right: 0;
  bottom: 6px;
  font-size: 13px;
  color: rgba(9, 7, 65, 0.35);
}
.invoice-search-box {
  border: 1px solid rgba(9, 7, 65, 0.2);
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 16px;
}
.invoice-search-label {
  font-weight: 600;
  font-size: 14px;
  color: rgba(9, 7, 65, 0.5);
  margin-bottom: 8px;
}
.invoice-btn-search {
  background: #090741;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 28px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  text-transform: uppercase;
}
.invoice-btn-search:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.invoice-result-box {
  border: 1px solid rgba(9, 7, 65, 0.1);
  border-radius: 5px;
  padding: 14px 18px;
  margin-bottom: 16px;
}
.invoice-result-name {
  font-weight: 600;
  font-size: 15px;
  color: rgba(9, 7, 65, 0.75);
  text-transform: uppercase;
  margin-bottom: 8px;
}
.invoice-result-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.invoice-result-label {
  display: block;
  font-weight: 600;
  font-size: 13px;
  color: rgba(9, 7, 65, 0.5);
}
.invoice-result-value {
  display: block;
  font-size: 14px;
  color: rgba(9, 7, 65, 0.75);
}
.invoice-btn-save {
  background: #090741;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}
.invoice-btn-close {
  background: #090741;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 6px 20px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}
</style>
